// Set the $ variable for WP
var $ = jQuery;

// Start AaltoMation
$(window).scroll(function(){
 inViewport();
});

$(window).resize(function(){
 inViewport();
});

var h = window.innerHeight;

function inViewport(){
	$('.aaltomation').each(function(){
		var divPos = $(this).offset().top,
		topOfWindow = $(window).scrollTop();
		
		if( divPos < topOfWindow+h-100 ){
			var animationClass = $(this).data('animation-in')
			$(this).removeClass('aaltomation');
			$(this).addClass('animate__animated');
			$(this).addClass(animationClass);
		}

		if( divPos < 100 ){
			console.log('gone');
		}
	});
}

console.log('Aaltomation Has Loaded');
// End AaltoMation



$( document ).ready(function() {
  $('#masonary_container').masonry({
    itemSelector: '#masonary_container .box'
  });
});


// Home Specific Scripts
if ($('body.page-template-home').length) {
	$(window).scroll(function(){
		var myElement = document.getElementById('scrolling-gallery');
		var bounding = myElement.getBoundingClientRect();
		var distanceToTop = window.pageYOffset + bounding.top;
		var scrollOffset = window.innerHeight - bounding.top;

		if ((bounding.top > 0 && bounding.top < window.innerHeight) || (bounding.bottom > 0 && bounding.bottom < window.innerHeight)) {
			$("#scrolling-gallery").css({"transform":"translateX(-" + scrollOffset + "px)"});
		} else {
			// console.log('Element is NOT in the viewport!');
		}
	});
}


// Single Listing
if ($('body.listing-template-default').length || $('body.page-template-default').length ) {
	$( document ).ready(function() {



        if($('.property-description').height() > 370){
            $('.property-description').addClass('property-description-hidden');
            
        }
        else{
            $('.property-description-show-more').hide();
        }

		$('.property-description-show-more').click(function(){
            $('.property-description').removeClass('property-description-hidden');
            $(this).hide();
		});



        
		
	});

    $('.swiper').imagesLoaded( function() {
    const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 30,
      autoHeight: true,
      mousewheel: false,
      loop: true,
      centeredSlides: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

        const miniSwiper = new Swiper('.mini-swiper', {

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }

        });
    });
}



// Single Agent
if ($('body.single-agent').length ) {
    $( document ).ready(function() {

    const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 30,
      autoHeight: true,
      mousewheel: false,
      loop: true,
      centeredSlides: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
        });

        const miniSwiper = new Swiper('.mini-swiper', {

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }

        });

        if($('.property-description').height() > 370){
            $('.property-description').addClass('property-description-hidden');
            
        }
        else{
            $('.property-description-show-more').hide();
        }

        $('.property-description-show-more').click(function(){
            $('.property-description').removeClass('property-description-hidden');
            $(this).hide();
        });

        
        
    });
}


//Modal

$( document ).ready(function() {

    $('.modal-copy-link').click(function(){

        //console.log($('#copy-link').val());

        const inputval = $('#copy-link').val();
        
        if (!navigator.clipboard){
            // use old commandExec() way
            // use if on local host or non-https
            // focus and select input text
            $('#copy-link').focus();
            $('#copy-link').select();

            //Copy
            document.execCommand('copy');
        } else{
            //Copy Link (Only works with Https)
            navigator.clipboard.writeText(inputval)
        }
    });

});


//Single Listing Features and Additional Details drop views

$( document ).ready(function() {

    $('.show-features').click(function() {
        
        $('.features').toggle("slide");
    });

    $('.show-additional').click(function() {
        
        $('.additionaldetails').toggle("slide");
    });

});





//Migrated Scripts

var LOCALURL = 'https://cwapi.tiddlytech.com/';
var STAGINGURL = 'https://cwapi.tiddlytech.com/';

/** Formats numbers entered in Wordpress. */
Number.prototype.formatMoney = function(decPlaces, thouSeparator, decSeparator) {
    var n = this,
        decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSeparator = decSeparator == undefined ? "." : decSeparator,
        thouSeparator = thouSeparator == undefined ? "," : thouSeparator,
        sign = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return sign + (j ? i.substr(0, j) + thouSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) + (decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
};

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null){
       return null;
    }
    else{
       return results[1] || 0;
    }
}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');   
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}

/** Formats numbers to be displayed on map icons. 
(Probably better way to do this without all the if/elses to account for varying amounts of digits) */
function formatMapPrice(priceNum) {
    var prettyPrice = "";
    priceNum = priceNum.toString();

    if(priceNum.indexOf(".") > -1){
        priceNum = priceNum.substr(0, priceNum.length-3);
    }

    if (priceNum.length === 8){
        prettyPrice = priceNum.substring(0,2)+"."+priceNum.substring(2,3)+"m";
    }
    else if (priceNum.length === 7){
        prettyPrice = priceNum.substring(0,1)+"."+priceNum.substring(1,2)+"m";
    }
    else if (priceNum.length === 6){
        prettyPrice = priceNum.substring(0,3)+"k";
    }
    else if (priceNum.length === 5){
        prettyPrice = priceNum.substring(0,2)+"k";
    }
    else if (priceNum.length === 4){
        prettyPrice = priceNum.substring(0,1)+"k";
    }

    return prettyPrice;
}


/** Sticks map to top on scroll for property search. */
function affixElement(el) {
    var scrollTop = $(window).scrollTop(),
        that_top = el.data('top') ? $(el.data('top')).offset().top : 0,
        that_btm = el.data('bottom') ? $(el.data('bottom')).outerHeight(true) + $(el.data('bottom')).offset().top : 0;

    var elBottom = scrollTop + el.outerHeight();
    
       
    if(scrollTop < that_top) {
      el.scrollTop(0);
      el.addClass('affix-top').removeClass('affix-bottom').removeClass('affix-fix');
    }
    else if(elBottom > that_btm){
    	el.removeClass('affix-top').removeClass('affix-fix').addClass('affix-bottom');
    }
    else {
      el.removeClass('affix-top').removeClass('affix-bottom').addClass('affix-fix');
    }
    }

    $('.affix').each(function(){
    var that = $(this);
    affixElement(that);

    $(window).on('scroll', function(){
      affixElement(that);
    });

});


/** Centers images for thumbnail sliders. */
function centerImages(){
    var tHeight = $('.thumb-slider').height();
    var tWidth = $('.thumb-slider').width();

    var ftHeight = $('.f-thumb-slider').height();
    var ftWidth = $('.f-thumb-slider').width();

    $('.thumb-slide').height(tHeight);
    $('.thumb-slide').width(tWidth);

    $('.f-thumb-slider .thumb-slide').height(ftHeight);
    $('.f-thumb-slider .thumb-slide').width(ftWidth);
};



function setMapHeight(){

    var wHeight = $( window ).height();
    $("#map").css("height", wHeight+"px");
}


/** Functions for converting user friendly values to API friendly values for searching. */
function priceSearch(price){

    switch(price) {
    case "1":
        $("#minPrice").val(0);
        $("#maxPrice").val(250000);
        break;
    case "2":
        $("#minPrice").val(250000);
        $("#maxPrice").val(500000);
        break;
    case "3":
        $("#minPrice").val(500000);
        $("#maxPrice").val(1000000);
        break;
    case "4":
        $("#minPrice").val(1000000);
        $("#maxPrice").val(2000000);
        break;
    case "5":
        $("#minPrice").val(2000000);
        $("#maxPrice").val(5000000);
        break;
    case "6":
        $("#minPrice").val(5000000);
        $("#maxPrice").val('');
        break;

    default:
        $("#minPrice").val(0);
        $("#maxPrice").val(100000000);
    }
}



function acreSearch(acres){
    switch(acres) {
    case "1":
        $("#minAcres").val(0);
        $("#maxAcres").val(2);
        break;
    case "2":
        $("#minAcres").val(2);
        $("#maxAcres").val(5);
        break;
    case "3":
        $("#minAcres").val(5);
        $("#maxAcres").val(10);
        break;
    case "4":
        $("#minAcres").val(10);
        $("#maxAcres").val(20);
        break;
    case "5":
        $("#minAcres").val(20);
        $("#maxAcres").val(50);
        break;
    case "6":
        $("#minAcres").val(50);
        $("#maxAcres").val(1000000);
        break;
    default:
        $("#minAcres").val(0);
        $("#maxAcres").val(100000);
    }
}



function bedSearch(beds){

    if(beds != '') {
        $("#minBeds").val(beds);
    }
    else{
        $("#minBeds").val('');
    }
}


/** Grabs a single property from the MLS. Called in page-mris.php */
function getProperty(id){


    var listing = id;
		
    if(window.location.href.indexOf(".dev") > -1 || window.location.href.indexOf(".local") > -1) {
       var url = LOCALURL+"single/"+listing; // pass to local url if using local environment.
    }
    else{
       var url = STAGINGURL+"single/"+listing;
    }

    $.ajax({
           type: "POST",
           url: url,
           data: $("#getproperty").serialize(), // serializes the form's elements.
           success: function(response)
           {
                


                console.log(response);

                var price = response.ListPrice;
                var formatPrice;
                var priceNum = parseInt(price, 10);
                var mapPrice = formatMapPrice(price);

                var source = $('#property-template').html();
                var template = Handlebars.compile(source);
                var html = template(response);
                $('.mls-content').html(html);

                

                var directions = $('#directions-template').html();
                var dtemplate = Handlebars.compile(directions);
                var dhtml = dtemplate(response);
                $('.directions-container').html(dhtml);

                var images = JSON.parse(response.Images);
                var totalImages = images.length;
                var loaded = 0;
                var tallest = 0;

                
                var related = {ListingKey:"", ListPrice:"", PropertyType:"", County:"", id:"", relimit:"3"};
                
                related.id = response.id.toString();
                related.ListingKey = response.ListingKey.toString();
                related.ListPrice = response.ListPrice.toString(); 
                related.PropertyType = response.PropertyType.toString(); 
                related.County = response.County.toString();

                if ( $( "#single-map" ).length ) { //If the page has a single map element add the property marker to it
                    var map = L.map('single-map', {
                        scrollWheelZoom: false,
                        dragging: true
                    });
                    var plain = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                        attribution: '<a href="http://mapbox.com">Mapbox</a>',
                        minZoom: 8,
                        maxZoom: 18,
                        id: 'mapbox/streets-v11',
                        accessToken: 'pk.eyJ1IjoidmliZXRoaW5rIiwiYSI6IlZXcEV5czAifQ.zIRUvZmeD2snWdx7TlAj3g'
                    }).addTo(map);
                    var sat = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                        attribution: '<a href="http://mapbox.com">Mapbox</a>',
                        minZoom: 8,
                        maxZoom: 18,
                        id: 'mapbox/streets-v11',
                        accessToken: 'pk.eyJ1IjoidmliZXRoaW5rIiwiYSI6IlZXcEV5czAifQ.zIRUvZmeD2snWdx7TlAj3g'
                    });
                    $( "#single-map" ).height(600);
                    var markers = L.layerGroup().addTo(map);
                }//endif #single-map

                var featuredProperty = new L.layerGroup().addTo(markers);

                markers.addLayer(new L.marker([response.Latitude,response.Longitude]), {});
                map.setView([response.Latitude,response.Longitude], 12);

                getRelatedProperties(related);

                $('.swiper img').on('load', function(){

                    loaded++;
                    //wait until all images are loaded before we call the slider funtion and only create slider if more than one property image
                    if(loaded == totalImages && totalImages > 1){
                        setPropertySlider(tallest); 
                    }

                    
                });

                $( document ).ready(function() {

               

								const miniSwiper = new Swiper('.mini-swiper', {

								  // Navigation arrows
								  navigation: {
								    nextEl: '.swiper-button-next',
								    prevEl: '.swiper-button-prev',
								  }

								});

                                if($('.property-description').height() > 370){
                                    $('.property-description').addClass('property-description-hidden');
                                    
                                }
                                else{
                                    $('.property-description-show-more').hide();
                                }

								$('.property-description-show-more').click(function(){
						    	$('.property-description').removeClass('property-description-hidden');
						    	$(this).hide();
								});
                            });

                if(response.TotalPhotos === "0" || response.TotalPhotos === 0 ){
                    $(".slider-nav").hide();
                    $(".property-slider").hide();
                }



               // $('.swiper').ready(function(){
               //      $('.swiper-button-next').trigger('click');
               //  }); 

                $('.plain').click(function(){
                    $('.satellite').removeClass('active');
                    $(this).addClass('active');

                    map.removeLayer(sat);
                    map.addLayer(plain);

                    return false;
                });

                $('.satellite').click(function(){
                    $('.plain').removeClass('active');
                    $(this).addClass('active');

                    map.removeLayer(plain);
                    map.addLayer(sat);

                    return false;
                });

                $('.read-intro').click(function(){
                    if ($(this).hasClass('active')){
                        var setHeight = 100;
                        $(this).removeClass('active');
                    }
                    else{
                        var setHeight = $(this).parent().height() + 70;
                        $(this).addClass('active');
                    }
                    
                    $(this).closest('.property-intro').css('height', setHeight);

                    return false;
                });
            }
    });

    return false; // avoid to execute the actual submit of the form.
}//end getProperty()

/** Grabs a collection of properties from the MLS. Called in footer.php and taxonomy-listing-categories.php */
function getCollection(properties, isNew){

    if(window.location.href.indexOf(".dev") > -1 || window.location.href.indexOf(".local") > -1) {
       var url = LOCALURL+"collection";
    }
    else{
       var url = STAGINGURL+"collection";
    }

    $.ajax({
           type: "POST",
           url: url,
           data: {properties:properties},
           success: function(response)
           {
                console.log(response);
                response.data = response;
                if(isNew === true){
                    var source = $('#new-collection-template').html();
                    var template = Handlebars.compile(source);
                    var html = template(response);
                    $('.head-featured').append(html);
                }
                else{
                    var source = $('#collection-template').html();
                    var template = Handlebars.compile(source);
                    var html = template(response);
                    $('.collection-list').append(html);
                }
                loaded = 0;
                $('.mini-swiper img').on('load', function(){

                    loaded++;
                    //wait until all images are loaded before we call the slider funtion and only create slider if more than one property image
                    if(loaded == 2){
                        setPropertySlider(); 
                    }

                    
                });

               
            }
    });

    return false; // avoid to execute the actual submit of the form.
}// END getCollection(properties, isNew)

/** Grabs a collection of recently listed properties from the MLS. Called in taxonomy-listing-categories.php */
function getRecent(county, page, pagination){

    if(window.location.href.indexOf(".dev") > -1 || window.location.href.indexOf(".local") > -1) {
       var url = LOCALURL+"recent";
    }
    else{
       var url = STAGINGURL+"recent";
    }
    $.ajax({
           type: "POST",
           url: url,
           data: {county:county,page:page},
           success: function(response)
           {

                    var myItems = response.data;
                    var totalListings = response.total;
                    var source = $('#collection-template').html();
                    var template = Handlebars.compile(source);
                    var html = template(response);
                    if(pagination === true){
                        $('.collection-list').html(html);
                    }
                    else{
                        $('.collection-list').append(html);
                    }
                    setSliders();

                    var width = $(window).width();
                var edges = 4;
                //change amount of pagination numbers that are shown based on window width
                if (width <= 640){ 
                    edges = 2;
                }

                $(function() {
                    $(".result-pagination").pagination({
                        items: totalListings,
                        itemsOnPage: 12,
                        currentPage: response.current_page,
                        cssStyle: 'compact-theme',
                        hrefTextPrefix: '#',
                        edges: edges,
                        prevText: '<i class="fa fa-caret-left"></i>',
                        nextText: '<i class="fa fa-caret-right"></i>',
                        onPageClick: function(pageNumber){
                             $("#page").val(pageNumber);
                            getRecent(county, pageNumber, true);
                         }
                    });
                });

                //set pagination width dynamically so pagination bar is always full width
                var paginationListItems = $(".simple-pagination li").length;
                var paginationItemWidth = 100 / paginationListItems;
                $(".simple-pagination li").css("width",paginationItemWidth+"%");

                var resultHeight = $(".simple-pagination li").length;
            }
    });

    return false; // avoid to execute the actual submit of the form.
}// END getRecent(county, page, pagination)


/** Grabs a collection of related properties from the MLS. Called in single-listing.php and page-mris.php */
function getRelatedProperties(property){

    if(window.location.href.indexOf(".dev") > -1 || window.location.href.indexOf(".local") > -1) {
       var url = LOCALURL+"search";
    }
    else{
       var url = STAGINGURL+"search";
    }

    $.ajax({
           type: "POST",
           url: url,
           data: property,
           success: function(response)
           {

                if(response.total > 0){
                    var source = $('#related-property-template').html();
                    var template = Handlebars.compile(source);
                    var html = template(response);
                    $('.related-properties').html(html);
                        $('.related-property-slider').slick({
                          dots: false,
                          slide: ".slide-container",
                          arrows:true,
                          infinite: true,
                          speed: 300,
                          slidesToShow: 4,
                          slidesToScroll: 4,
                          prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
                          nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>',
                          responsive: [
                                {
                                  breakpoint: 1200,
                                  settings: {
                                    arrows: true,
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    dots: false
                                  }
                                },
                                {
                                  breakpoint: 1025,
                                  settings: {
                                    arrows: true,
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    dots: false
                                  }
                                },
                                {
                                  breakpoint: 640,
                                  settings: {
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                  }
                                }
                              ]
                        });    
                    //setSliders();
                }
            }
    });

    return false; // avoid to execute the actual submit of the form.
}// END getRelatedProperties(property)

/** Passes form parameters to MLS on property search page */
function propertySearch(paginate, page, isNew){

    if(!$("body").hasClass('page-template-page-property-search')){
        return;
    }

    if(window.location.href.indexOf(".dev") > -1 || window.location.href.indexOf(".local") > -1) {
       var url = LOCALURL+"search";
    }
    else{
       var url = STAGINGURL+"search";
    }
    $("#perpage").val("12");



    if (window.location.hash !== ''){
        
        if (paginate === true){
            var newPage = page;
        }
        else{
            var newPage = window.location.hash.substr(1);
        }
        if( isNew === true){
            $("#page").val("1");
        }
        else{
            $("#page").val(newPage);
        }
    }

    $.ajax({
           type: "POST",
           url: url,
           data: $("#psearch").serialize(), // serializes the form's elements.
           success: function(response)
           {
                console.log(response);
                markers.clearLayers();    
                var myItems = [];
                var myItems = response.data;
                var totalListings = response.total;
                var featuredResults = new L.FeatureGroup().addTo(markers);
                var width = $(window).width();
                var edges = 2;
                //change amount of pagination numbers that are shown based on window width
                if (width <= 640){ 
                    edges = 1;
                }


                $(function() {
                    $(".result-pagination").pagination({
                        items: totalListings,
                        itemsOnPage: 12,
                        currentPage: response.current_page,
                        displayedPages: 3,
                        cssStyle: 'compact-theme',
                        hrefTextPrefix: '#',
                        edges: 1,
                        prevText: '<i class="fa fa-caret-left"></i>',
                        nextText: '<i class="fa fa-caret-right"></i>',
                        onPageClick: function(pageNumber){
                            $("#page").val(pageNumber);
                            propertySearch(true, pageNumber);
                            mapSearch(true, pageNumber);
                        }
                    });
                });

                //set pagination width dynamically so pagination bar is always full width
                var paginationListItems = $(".simple-pagination li").length;
                var paginationItemWidth = 100 / paginationListItems;
                var updatedCheck = moment().subtract(6, 'days');
                $(".simple-pagination li").css("width",paginationItemWidth+"%");

                var resultHeight = $(".simple-pagination li").length;

                //var html = "<span class='total-results'>"+totalListings+" Results Found</span>"; 
                var html = "<ul class='results row large-up-2' data-equalizer>";

                for (var i = 0; i < myItems.length; i++) {
                    var item = myItems[i];
                    var slug = item['Title'].split(' ').join('-');//convert property name to a slug for use in url string
                    var price = item['ListPrice'];
                    var acres = item['LotAreaAcre'];
                    var formatPrice;
                    var priceNum = parseInt(price, 10); //make sure price is an int for formatting
                    var acreNum = parseFloat(acres, 10);
                    var formatAcre = acreNum.formatMoney(1,',','.');
                    var mapPrice = formatMapPrice(price); //format price to format shown on map icons
                    var WPLink = item['WordPressLink'];
                    var WPTitle = item['WordPressTitle'];
                    var WPStatus = item['ListingStatus'];
                    var MLSFeature = item['MLSFeatured'];
                    var propLink = '';
                    var propTitle = '';
                    var imgDirectory = item['ListingKey'];
                    var priceUpdate = moment(item['PriceDropTimestamp']);


                    

                    if(item['Featured'] === 3){
                        imgDirectory = item['WordpressID'];
                        item['ListingKey'] = item['WordpressID'];
                    }

                    formatPrice = '$' + priceNum.formatMoney(0,',','.');//format price for format used in listings
                    html += "<li id='"+item['ListingKey']+"' class='archive-card-grid listing-card column' data-property='"+item['ListingKey']+"''>";
                    html += "<article role='article'>";
                    html += "<section class='featured-image' itemprop='text'>";
                    //html += "<div id='thumb-slider-"+i+"' data-property='"+item['ListingKey']+"' class='property-thumb thumb-slider center-images'>";


                    try{
                        var imgs = JSON.parse(item['Images']); //turn json images string into an array for looping through
                    }
                    catch(exception){
                        imgs = null;   
                    }

                    if(WPLink !== '' && MLSFeature === 0){
                        propLink = WPLink;
                        propTitle = WPTitle;
                    }
                    else if(WPLink !== '' && MLSFeature === 1){
                       propLink = "/listings/mris/"+item['ListingKey']+"/"+slug;
                       propTitle = WPTitle;
                    }
                    else{
                       propLink = "/listings/mris/"+item['ListingKey']+"/"+slug;
                       propTitle = item['Title'];
                    }

                    //html+= "<h3>"+propTitle+"</h3>";

                    html+= "<div class='swiper mini-swiper'><div class='swiper-button-prev'></div><div class='swiper-button-next'></div><div class='swiper-wrapper'>";

                    if(imgs !== null){

                        var thumbTotal = 4;
                        if(imgs.length < 4){
                            thumbTotal = imgs.length;
                        }
                        for (var j = 0; j < thumbTotal; j++) {
                            html += "<div class='swiper-slide'><a class='result-link' href='"+propLink+"'><img data-property='"+item['ListingKey']+"' src='"+STAGINGURL+"images/listings/"+imgDirectory+"/"+imgs[j]+"'/></a></div>";
                        }
                    }
                    else{
                        html+= "<div class='swiper-slide'><a class='result-link' href='"+propLink+"'><img data-property='"+item['ListingKey']+"' src='https://place-hold.it/320x180?text=Image Coming Soon'/></a></div>";
                    }

                    html += "</div></div></section><section class='listing-card-meta'><a href='"+propLink+"'>"+propTitle+"</a><br/>";   

                    html += "<span class='price'>"+formatPrice+"</span>";
                    if(WPStatus == "Contract"){
                    	html+= "<span class='active-listing contracted'>Under Contract</span>";
                    }
                    else{
                    	html+= "<span class='active-listing'>Active</span>";
                    }
                    
                    if(item['Beds'] != "" || item['BathsFull'] != 0 || item['LotAreaAcre'] != "0.0"){
                        html += "<div class='listing-card-meta-details' data-equalizer-watch>";

                        if(item['PropertyType'] != "Lot-Land"){

                            if (item['Beds'] != ""){
                                html += ""+item['Beds']+" Beds<span class='spacer'>&bull;</span>";
                            }

                            if (item['Baths'] != "0.0"){
                                html += ""+item['BathsFull']+" Baths<span class='spacer'>&bull;</span>";
                            }

                        }

                        if (item['LotAreaAcre'] != "" && item['LotAreaAcre'] != "0.0"){
                                html += ""+formatAcre+" Acres";
                        }

                        html+= "</div></section></article></div>";
                    }


                    

                    if(WPLink !== '' && MLSFeature === 0){
                        html+= "<span class='cwr-exclusive-label'>CWR Listing</span>";
                    }
                    // if(moment(priceUpdate).isAfter(updatedCheck) && item['DaysOnMarket'] > 7){
                    //     html+= "<span class='pdrop'>New Price<i class='fa fa-arrow-down'></i></span>";
                    // }
                    // if(item['DaysOnMarket'] < 8){
                    //     html+= "<span class='pdrop'>New<i class='fa fa-asterisk'></i></span>";
                    // }

                    html+= "</li>";

                    var featuredIcon = L.divIcon({  
                        html: '<div id="'+item['ListingKey']+'" class="priceIcon" data-property="'+item['ListingKey']+'">'+mapPrice+'</div>'
                    });

                    if(WPLink !== ''){
                    // create popup contents
                        var featuredPopup = "<div class='map-pop'><a href='"+WPLink+"'><h2>"+WPTitle+"</h2><br/><span>View Listing</span></a></div>";
                    }
                    else{
                    var featuredPopup = "<div class='row expanded collapse'><div class='column small-4'><a class='result-link' href='/listings/mris/"+item['ListingKey']+"/"+slug+"'><img data-property='"+item['ListingKey']+"' src='"+STAGINGURL+"images/listings/"+imgDirectory+"/"+imgs[0]+"'/></a></div><div class='column small-8'<span>";
	                    if(item['Beds'] != "" || item['BathsFull'] != 0 || item['LotAreaAcre'] != "0.0"){
	                        featuredPopup += "<div class='listing-card-meta-details' data-equalizer-watch> <h2 class='price'>"+formatPrice+"</h3>";

	                        if(item['PropertyType'] != "Lot-Land"){

	                            if (item['Beds'] != ""){
	                                featuredPopup += ""+item['Beds']+" Beds <span class='spacer'>&bull; </span>";
	                            }

	                            if (item['Baths'] != "0.0"){
	                                featuredPopup += ""+item['BathsFull']+" Baths <span class='spacer'>&bull; </span>";
	                            }

	                        }

	                        if (item['LotAreaAcre'] != "" && item['LotAreaAcre'] != "0.0"){
	                                featuredPopup += ""+formatAcre+" Acres";
	                        }

	                        featuredPopup += "<br/><a href='/listings/mris/"+item['ListingKey']+"/"+slug+"'><h2>"+item["Title"]+"</h2><br/><span>View Listing</span></a></div></div>";

	                    }
	                  }
                    
                    // specify popup options 
                    var customOptions =
                        {
                        'maxWidth': '320',
                        'className' : 'custom-pop'
                        }
                    if(item['Latitude'] !== ''){
                        featuredResults.addLayer(new L.marker([item['Latitude'],item['Longitude']], {icon: featuredIcon}).bindPopup(featuredPopup,customOptions), {});
                    }
                }
                html += "</ul>";
                if(paginate != true){
                    mapSearch();
                }
                $('#search-results').html(html);
                $(".priceIcon").parent().css('z-index', '9999');

                const swiper = new Swiper('.swiper', {

								  // Navigation arrows
								  navigation: {
								    nextEl: '.swiper-button-next',
								    prevEl: '.swiper-button-prev',
								  }

								});

								// const miniSwiper = new Swiper('.mini-swiper', {

								//   // Navigation arrows
								//   navigation: {
								//     nextEl: '.swiper-button-next',
								//     prevEl: '.swiper-button-prev',
								//   }

								// });

                //setSliders();

                if($('#input_1_1').val() !== ''){
                    //map.addLayer(markers);
                    console.log(featuredResults);
                    
                    var bounds = featuredResults.getBounds();
                    
                    map.fitBounds(bounds, {padding: [150, 150]});
                }
            }
    });

    return false; // avoid to execute the actual submit of the form.
}// END propertySearch(paginate)



function mapSearch(paginate, page){

    if(window.location.href.indexOf(".dev") > -1 || window.location.href.indexOf(".local") > -1) {
       var url = LOCALURL+"search"; // the script where you handle the form input.
    }
    else{
       var url = "https://cwapi.tiddlytech.com/search"; // the script where you handle the form input.
    }

    $("#page").val("1");
    $("#perpage").val("1000");

    $.ajax({
           type: "POST",
           url: url,
           data: $("#psearch").serialize(), // serializes the form's elements.
           success: function(response)
           {
                //console.log(response); // show response from the php script.
                // if(markers.hasLayer(results)){
                //     console.log("has-markers");
                //     markers.removeLayer(results); 
                // }   
                var results = new L.MarkerClusterGroup({ maxClusterRadius: 10, showCoverageOnHover: false }).addTo(markers);
                var myItems = [];
                var myItems = response.data;

                for (var i = 12; i < myItems.length; i++) {
                    var item = myItems[i];
                    var price = item['ListPrice'];
                    var priceNum = formatMapPrice(price);
                    var WPLink = item['WordPressLink'];
                    var WPTitle = item['WordPressTitle'];

                    

                    var myIcon = L.divIcon({  
                        html: '<div class="marker-cluster"><div id="'+item['ListingKey']+'" data-property="'+item['ListingKey']+'"></div></div>'
                    });

                    if(WPLink !== ''){
                    // create popup contents
                        var customPopup = "<div class='map-pop'><a href='"+WPLink+"'><h2>"+WPTitle+"</h2><br/><span>View Listing</span></a></div>";
                    }
                    else{
                        var customPopup = "<div class='map-pop'><a href='/listings/"+item['ListingKey']+"'><h2>"+item["Title"]+"</h2><br/><span>View Listing</span></a></div>";
                    }
                    
                    // specify popup options 
                    var customOptions =
                        {
                        'maxWidth': '120',
                        'className' : 'custom-pop'
                        }
                    results.addLayer(new L.marker([item['Latitude'],item['Longitude']], {icon: myIcon}).bindPopup(customPopup,customOptions), {
                    });
                }
                if($('#input_1_1').val() !== ''){
                    //map.addLayer(markers);
                    var bounds = results.getBounds();
                   
                    
                    if(bounds.isValid()){
                    	map.setView([38.6625654,-77.9397774], 10);
                    	map.fitBounds(bounds, {padding: [50, 50]});
                  	}
                  	
                }

            },
            complete: function(){

            }
    });
    return false; // avoid to execute the actual submit of the form.
} //END mapSearch(paginate, page)

function addOrUpdateUrlParam(name, value)
{
	
	value = value.split(/[,]+/).join('%2c');
	
  var href = window.location.href;
  
  var regex = new RegExp("[&\\?]" + name + "=");
  
  if(regex.test(href))
  {
  	
    regex = new RegExp("([&\\?])" + name + "=\\d+");
    window.location.href = href.replace(regex, "$1" + name + "=" + value);
  }
  else
  {
  	
    if(href.indexOf("?") > -1)
      window.location.href = href + "&" + name + "=" + value;
    else
      window.location.href = href + "?" + name + "=" + value;
  }
  
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if( value === undefined ) {
  	if (uri.match(re)) {
		return uri.replace(re, '$1$2').replace(/[?&]$/, '').replaceAll(/([?&])&+/g, '$1').replace(/[?&]#/, '#');
	} else {
		return uri;
	}
  } else {
  	if (uri.match(re)) {
  		return uri.replace(re, '$1' + key + "=" + value + '$2');
	} else {
    var hash =  '';
    if( uri.indexOf('#') !== -1 ){
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
    }
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";    
    return uri + separator + key + "=" + value + hash;
  }
  }  
}


function staff_ajax_get(agent) {

    //console.log(agent);
            
    $.ajax({
        type: 'POST',
        url: ajaxfilter.ajaxurl,
        data: {action: 'load_staff_posts', id: agent },
        beforeSend: function() {
        
      },
        success: function(response) {

            $('.property-agent').append( response );
            
            return false;
        }
    });
};

$(".pricing").on('keyup', function(){
    var n = parseInt($(this).val().replace(/\D/g,''),10);
    $(this).val(n.toLocaleString());
    
});

$('.price-min').on('keyup', function(){
    var stripMin = $(this).val().replace(/\D/g,'');
    $('input[name=minPrice]').val(stripMin);
});

$('.price-max').on('keyup', function(){
    var stripMax = $(this).val().replace(/\D/g,'');
    $('input[name=maxPrice]').val(stripMax);
});

/** Listeners for passing data from mobile input fields to main input fields used for search. */
$('.mobileminPrice').on('keyup', function(){
    var stripMin = $(this).val().replace(/\D/g,'');
    $('input[name=minPrice]').val(stripMin);
});

$('.mobilemaxPrice').on('keyup', function(){
    var stripMax = $(this).val().replace(/\D/g,'');
    $('input[name=maxPrice]').val(this.value);
});

$('.mobilebeds').on('change', function(){
    $('input[name=beds]').val(this.value);
});

$('.mobileptype').on('change', function(){
    $("#ptype").val(this.value);
    propertySearch();
});

$('.view-select a').on('click', function(){

	if(!$(this).hasClass('selected')){



		if($(this).hasClass('map-btn')){

			$('.list-btn').removeClass('selected');
			$(this).addClass('selected');
			$('#search-results-container').removeClass('medium-12');
			$('#search-results-container').addClass('medium-7');
			
			$('#search-results').addClass('expanded');
			$('.results').removeClass('large-up-3 expanded');
			$('.results').addClass('large-up-2');
			
			$('.search-map-container').show();

		}
		else{
			$('.map-btn').removeClass('selected');
			$(this).addClass('selected');
			$('.search-map-container').hide();
			$('#search-results-container').removeClass('medium-7');
			$('#search-results-container').addClass('medium-12');
			$('#search-results').addClass('expanded');
			$('.results').removeClass('large-up-2');
			$('.results').addClass('large-up-3 expanded');
		}

	}

});

$('.filter-btn li').on('click', function(){

				var county = $('input[name=County]').val();

				

				if ($(this).hasClass('selected')){



					$('input[name=County]').val(county.replace($(this).data('county'), ''));
					
				}
				else{
					if(county.length === 0){
						$('input[name=County]').val($(this).data('county'));
						
					}
					
					else{
						$('input[name=County]').val(county + ' ' + $(this).data('county'));
						
					}
				}
				$(this).toggleClass('selected');

				if(!$('.filter-btn li.selected').length){
					$('input[name=County]').val('');
					

				}
					var formCounty = $('#county').val();
					var urlCounty = formCounty.split(/[ ,]+/).filter(function(v){return v!==''}).join(',');
					window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "county", formCounty.toString()));
					//console.log(urlCounty);
					// addOrUpdateUrlParam('county', urlCounty );
         	propertySearch(false, false, true);
    });



/** Resets map boundary values if a new keyword is being searched for. */
$('#input_1_1').on('change', function(){
    $("#limit").val("");
    $('input[name=swlatbounds]').val('');
    $('input[name=swlongbounds]').val('');
    $('input[name=nelatbounds]').val('');
    $('input[name=nelongbounds]').val('');
});


/** Removes limit from recent properties list if any search criteria has changed. */
$('select').on('change', function(){
    $("#page").val("1");
    $("#limit").val("");
});


/** Takes user friendly values from form and converts them to API friendly values used for searching. */
$('select[name=beds]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "beds", this.value.toString()));
		//addOrUpdateUrlParam('beds', this.value);
    bedSearch(this.value);
    propertySearch(false, false, true);
});

$('select[name=acres]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "acres", this.value.toString()));
		//addOrUpdateUrlParam('acres', this.value);
    acreSearch(this.value);
    propertySearch(false, false, true);
});
$('select[name=mobileacres]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "acres", this.value.toString()));

    acreSearch(this.value);
    propertySearch(false, false, true);
});

$('select[name=price]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "price", this.value.toString()));

		//addOrUpdateUrlParam('price', this.value);
    priceSearch(this.value);
    propertySearch(false, false, true);
});

$('select[name=ptype]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "ptype", this.value.toString()));

		//addOrUpdateUrlParam('ptype', this.value);
    propertySearch(false, false, true);
});

$('select[name=sortby]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "sortby", this.value.toString()));

		//addOrUpdateUrlParam('sortby', this.value);
    if(this.value === 'DaysOnMarket'){
    		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "sortorder", 'ASC'));
    		//addOrUpdateUrlParam('sortorder', 'ASC');
        $("#sortorder").val('ASC');
    }
    propertySearch(false, false, true);
});

$('select[name=sortorder]').on('change', function(){
		window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "sortorder", this.value.toString()));

		//addOrUpdateUrlParam('sortorder', this.value);
    propertySearch(false, false, true);
});


/** Resets map boundary values if a new search is submitted. */
$("#psearch").submit(function(e) {
    e.preventDefault();
    window.history.pushState(null, null, updateQueryStringParameter(window.location.href, "keyword", $('#input_1_1').val().toString()));

    //addOrUpdateUrlParam('keyword', $('#input_1_1').val());
    //addOrUpdateUrlParam('county', $('#county').val());
    $("#limit").val("");
    $('input[name=swlatbounds]').val('');
    $('input[name=swlongbounds]').val('');
    $('input[name=nelatbounds]').val('');
    $('input[name=nelongbounds]').val('');
    propertySearch(false, false, true);
});


/** Fades in slider arrows on hover of multiple slider types. */



/** Highlights property icon on map when property is hovered over in search results. */
$('#search-results').on('mouseover', 'li', function(e){
    var hoverID = $(e.target).data('property');
    $("#map .priceIcon").removeClass('hovered');
    $("#map #"+hoverID).addClass('hovered');
    $("#map #"+hoverID).parent().css('z-index', '99999');
    $(this).find('.slick-arrow i').fadeIn();
});

$('#search-results').on('mouseleave', 'li', function(e){
    var hoverID = $(e.target).data('property');
    $("#map #"+hoverID).removeClass('hovered');
    $("#map #"+hoverID).parent().css('z-index', '9999');
    $(this).find('.slick-arrow i').fadeOut();
});


/** Sets map height to window height on search page. */
var wHeight = $( window ).height();
$("#map").css("height", wHeight+"px");
$(".search-content").css("min-height", wHeight+"px");
$(".search-map-container").css("min-height", wHeight+"px");

if ( $( "#map" ).length ) {
    var map = L.map('map', {
        scrollWheelZoom: false
    }).setView([38.6625654,-77.9397774], 9);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
        attribution: '<a href="http://mapbox.com">Mapbox</a>',
        minZoom: 8,
        maxZoom: 18,
        id: 'mapbox/streets-v11',
        accessToken: 'pk.eyJ1IjoidmliZXRoaW5rIiwiYSI6IlZXcEV5czAifQ.zIRUvZmeD2snWdx7TlAj3g'
    }).addTo(map);

    var markers = L.layerGroup().addTo(map);
}

// $(document).foundation({
//   equalizer : {
//     equalize_on_stack: true,
//   }
// });

// $(document).foundation({
//   accordion: {
//     // specify the class used for accordion panels
//     content_class: 'content',
//     // specify the class used for active (or open) accordion panels
//     active_class: 'active',
//     // allow multiple accordion panels to be active at the same time
//     multi_expand: true,
//     // allow accordion panels to be closed by clicking on their headers
//     // setting to false only closes accordion panels when another is opened
//     toggleable: true
//   }
// });


/** Setting masonry layout on testimonials page. */
// var container = $('.test-isotope');
// container.isotope({
//   itemSelector: 'li',
//   layoutMode: 'masonry'
// });

// $(window).load( function() {
//     container.isotope('layout');
// });



/** Recalling layout functions after certain interchanges happen. */
// $(document).on('replace', 'img', function (e, new_path, original_path) {

//     $(document).foundation('equalizer', 'reflow');
//     centerImages();

// });

// $(document).on('replace', '.about-services', function (e, new_path, original_path) {

//     $('.service-slider').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true
//     });
// });

// $(document).on('replace', '.seller-services', function (e, new_path, original_path) {

//     $('.service-slider').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true
//     });
// });




/** Setting up misc site sliders. */



$('.thumb-slider').each(function (idx, item) {

        var carouselId = "thumb-slider-" + idx;
        this.id = carouselId;  
        var carousel = "#" + carouselId;

        $(carousel).slick({
          dots: false,
          arrows:true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
          nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
        });
    });


// as the page loads, call these scripts
jQuery(document).ready(function($) {
	// load Foundation
	jQuery(document).foundation();

    if($.urlParam('price')){
        priceSearch($.urlParam('price'));
    }

    if($.urlParam('beds')){
        bedSearch($.urlParam('beds'));
    }
    if($.urlParam('acres')){
        acreSearch($.urlParam('acres'));
    }
    if ( $( "#map" ).length ) {
        setMapHeight();
        propertySearch();
    }
	
    // load gravatars
    $('.comment img[data-gravatar]').each(function(){
        $(this).attr('src',$(this).attr('data-gravatar'));
    });

    $('#lightbox-close').click(function(){
        $('.lightbox-content').hide();
    });

    $(".js-header-leftnav-toggle").on("click", function(e) {
        $(this).addClass('active');
    });

    $(".exit-off-canvas").on("click", function(e) {
        $(".js-header-leftnav-toggle").removeClass('active');
    });

    /** Resets map boundary values if a new keyword is being searched for. */

    $(".bed-list li").on("click", function(e) {
        var element = $( this );
        var beds = element.data( "beds" );
        $("#minBeds").val(beds);
        $("#limit").val("");
        if(beds != ''){
            $("#bed-drop").html(beds+"+ Beds");
        }
        else{
            $("#bed-drop").html("Beds");   
        }
        if($("body").hasClass('page-template-page-property-search')){
            propertySearch(false, false, true);
        }
    });

    $(".type-list li").on("click", function(e) {
        var element = $( this );
        var type = element.data( "types" );
        $("#ptype").val(type);
        $("#limit").val("");
        if(type == "Lot-Land"){
            $("#type-drop").html("Land");
        }
        else if(type != '' && type != 'Lot-Land'){
            $("#type-drop").html(type);
        }
        else{
            $("#type-drop").html("Type");   
        }
        if($("body").hasClass('page-template-page-property-search')){
            propertySearch(false, false, true);
        }
    });
    

    /** Listeners for open/close of new properties & prices tab on desktop header. Also sets slider after being clicked on */
    $('.head-listing a').on('click', function(){
        $('.head-listings').slideToggle();
        $('.head-featured').slick({
            dots: false,
            slide: ".slide-container",
            arrows:true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
        });

        $(document).foundation('equalizer', 'reflow');
        
    });

    $('.close-head').on('click', function(){
        $('.head-listings').slideUp();
    });


    /** Passes map boundaries to search function to only search within viewable map area if searching using map controls. */
    if ( $( "#map" ).length ) {

        map.on('dragend zoomend', function(e) {
            var swLat = parseFloat(map.getBounds()._southWest.lat);
            var swLng = parseFloat(map.getBounds()._southWest.lng);
            var neLat = parseFloat(map.getBounds()._northEast.lat);
            var neLng = parseFloat(map.getBounds()._northEast.lng);

            $("#swlatbounds").val(swLat);
            $("#swlongbounds").val(swLng);
            $("#nelatbounds").val(neLat);
            $("#nelongbounds").val(neLng);
            $("#limit").val('');

            if($('#input_1_1').val() === ''){

                propertySearch(false, false, true);
            }
        });
    }

    /** If property only has 1 image change styles appropriately as slider won't be intitiated */
    if($("body").hasClass('single-listing')){

        var fimages = $('.property-slider img').length;

            if(fimages < 2){
                $(".slider-nav").hide();
                $(".property-slide img").css("display", "");
                $(".property-slide img").css("max-height", "500px");
                $(".property-slide img").css("margin", "0 auto");
            }
            else{
                setPropertySlider(); 
            }
    }

}); /* end of as page load scripts */

function setCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}


function getCookie(name) 
{
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function setPropertySlider()
{
    
    const swiper = new Swiper('.swiper', {
          direction: 'horizontal',
          slidesPerView: 'auto',
          initialSlide: 1,
          spaceBetween: 30,
          autoHeight: true,
          mousewheel: false,          
          loop: true,
          centeredSlides: true,
          

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

    const miniSwiper = new Swiper('.mini-swiper', {

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }

        });
    Foundation.reInit('equalizer');


}



$(window).on('load resize', function () {

    setMapHeight();
    centerImages();

    $('.slider-nav').width($('.property-slider .slick-current').width());
    var slideHeight = $('.property-slider').find("img").height();
    var navHeight = $('.slick-dots').height();
    var sliderHeight = slideHeight + navHeight;
    var wWidth = $(window).width();

    /** Sets slider height dynamically after all images have been loaded from MLS. */
    $('.property-slider').height(sliderHeight);


    /** Only call agent sliders on smal screens. */
    if($("body").hasClass('single-agent')){

        if (wWidth < 640 ){
            setAgentSliders();
        }
    }
        
    // $(document).foundation('interchange', 'reflow');
    // $(document).foundation('equalizer', 'reflow');

});/* end of on-load/resize scripts */




$(window).on('load', function () {
    /** Only add read more fadeout if descriptions are over a certain height. */
    if($('.block-height').height() > 210){
        $('.more-gradient').show();
        $('.expandable').css('height', '160px');
        $('.area-intro').css('height', '260px');
    }
});


/** Handlebar helpers to deal with logic where necessary. */
Handlebars.registerHelper('property_slider', function(data, key, options) {
    var ret = '';
    var context = JSON.parse(data);
    for(var i=0, j=context.length; i<j; i++) {
        ret += '<div class="swiper-slide"><img src=https://cwapi.tiddlytech.com/images/listings/'+key+'/'+ context[i] +'/></div>';
    }
    return ret;
});


Handlebars.registerHelper('formatPrice', function(data) {

    var priceNum = parseInt(data, 10);
    var formatted = '$' + priceNum.formatMoney(0,',','.');

    return formatted;
});

Handlebars.registerHelper('formatNumber', function(data) {

    var priceNum = parseInt(data, 10);
    var formatted = priceNum.formatMoney(0,',','.');

    return formatted;
});

Handlebars.registerHelper('formatSlug', function(data) {

    var slug = data.split(' ').join('-');

    return slug;
});

Handlebars.registerHelper('calcAcrePrice', function(acres, price) {

    var formatAcres = parseInt(acres, 10);
    var acrePrice = price/acres;
    var formatPrice = '$' + acrePrice.formatMoney(0,',','.');

    return formatPrice;
});

Handlebars.registerHelper('related_property_slider', function(data, key, lid, wid, title, link, feature, mls, options ) {
    var ret = '';
    var context = JSON.parse(data);
    var slug = title.split(' ').join('-');
    var propURL = '';

    var imgDirectory = key;

    if(feature === 3){
        imgDirectory = wid;
        key = wid;
    }

    if(link !== '' && mls === 0){
        propURL = link;
        
    }
    else{
        propURL = '/listings/mris/'+key+'/'+slug+'';
    }
    var relThumbTotal = 3;
    if(context.length < 3){
        relThumbTotal = context.length;
    }

    for(var i=0; i<relThumbTotal; i++) {

        ret += '<div class="swiper-slide"><a class="related-link" href="'+propURL+'"><img src="https://cwapi.tiddlytech.com/images/listings/'+imgDirectory+'/'+ context[i] +'"/></a></div>';
    }
    return ret;
});

Handlebars.registerHelper('Thumbnail', function(dafta, key) {
    var ret = '';
    var images = JSON.parse(dafta);
    ret = '<img src="https://api.cheriwoodard.com/images/listings/'+key+'/'+ images[0] +'"/>';

    return ret;
});

Handlebars.registerHelper('formatLink', function(key, title) {
    var ret = '';
    var slug = title.split(' ').join('-');
    ret = '<a href="/listings/mris/'+key+'/'+slug+'">';
    return ret;
});

Handlebars.registerHelper('formatDesc', function(data) {
    
    var ret = data.replaceAll(',', ', ');
    return ret;
});

Handlebars.registerHelper('if_eq', function(a, b, opts) {
    if(a === b) // Or === depending on your needs
        return opts.fn(this);
    else
        return opts.inverse(this);
});

Handlebars.registerHelper('if_not_eq', function(a, b, opts) {
    if(a === b) // Or === depending on your needs
        return opts.inverse(this);
    else    
        return opts.fn(this);
});

Handlebars.registerHelper('ifOr', function(v1, v2, v3, v4, v5, v6, v7, v8,  options) {
  if(v1 != '' || v2 != '' || v3 != '' || v4 != '' || v5 != '' || v6 == '1' || v7 == '1' || v8 != '' ) {
    return options.fn(this);
  }
  return options.inverse(this);
});



/** Adding markers to Google maps on CW listings that use ACF field to show map. */
(function($) {

function new_map( $el ) {
    
    // var
    var $markers = $el.find('.marker');
    
    
    // vars
    var args = {
        zoom        : 16,
        center      : new google.maps.LatLng(0, 0),
        scrollwheel: false,
        draggable: true,
        navigationControl: false,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
        
    // create map               
    var map = new google.maps.Map( $el[0], args);   
    
    // add a markers reference
    map.markers = [];
        
    // add markers
    $markers.each(function(){
        
        add_marker( $(this), map );
        
    });
    
    // center map
    center_map( map );
    
    // return
    return map;
    
}

function add_marker( $marker, map ) {

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker
    var marker = new google.maps.Marker({
        position    : latlng,
        map         : map,
        icon        : 'https://cheriwoodard.com/wp-content/themes/cheri/library/images/map-marker-icon.png'
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content     : $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {

            infowindow.open( map, marker );

        });
    }

}


function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 12 );
    }
    else
    {
        // fit to bounds
        map.fitBounds( bounds );
    }

}

var map = null;

$(document).ready(function(){

    $('.acf-map').each(function(){

        // create map
        map = new_map( $(this) );

    });

});

})(jQuery);
